module.exports = System.import('@enersis/gp-components/gp-editable-text');